"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styleTypes = require("./styleTypes");

var defaultProps = {
  componentName: "productList",
  cms: {
    style: {},
    content: {},
    media: {}
  },

  styleType: {
    style: {}
  },

  props: {
    style: {}
  }
};

exports.default = defaultProps;